<div>
  <div *ngFor="let item of data" class="up-next-list notification-list-item">
    <div class="date-display flex-column-0">
      <div class="coin-display info-background">{{date|localizeDate:'d'}}</div>
      <div class="month-display">
        <div class="date-month">{{date|localizeDate:'MMMM, YYYY'}}</div>
        <div class="date-day-of-week">{{date|localizeDate:'EEEE'}}</div>
      </div>
    </div>
    <div class="list-name flex-column-1">{{item.title}}: {{item.description}}</div>
    <div class="flex-column-0">
      <p-button variant="text" severity="info" (click)="navigate($event,item)"><span>{{'view'| translation}} {{item.target.type}} </span><i class="fas fa-chevron-right"></i></p-button>
    </div>
  </div>
</div>
<div *ngIf="data.length == 0" class="list-empty-notification">
  {{'no_tasks_assigned'| translation}}
</div>
